export enum AztecScannerResult {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}
